// Global settings for detections display and de-duplication behavior

const DetectionsConfig = {
  // Enable or disable ignoring repeated player detections within a time window
  ignoreRepeatEnabled: true,
  // Time window in seconds to ignore repeated detections of the same player
  ignoreRepeatSeconds: 5,

  // Overlay ticker speed controls
  // Approximate pixels per second for the marquee animation (normal vs fullscreen)
  overlayTickerSpeedPxPerSec: 220,
  // Slow down fullscreen marquee speed for better readability
  overlayTickerSpeedFullscreenPxPerSec: 180,
  // Minimum duration in seconds for a ticker pass (avoid too-fast flashes)
  overlayTickerMinDurationSec: 2,
  // Minimum duration in seconds when fullscreen (a bit slower)
  overlayTickerMinDurationFullscreenSec: 3,
  // If true, any new incoming detection interrupts the current ticker batch immediately.
  // For concurrent display of multiple batches, set this to false (default).
  overlayTickerInterruptOnNew: false,
  // Enable static tile display mode (required for tiles to show in overlay)
  overlayTickerStaticMode: true,
  // Maximum number of concurrent ticker rows (including the main row)
  overlayTickerMaxRows: 3,
  // Horizontal gap between player chips in the ticker (pixels)
  overlayTickerItemGapPx: 28,
  // Ticker height (px) normal vs fullscreen
  overlayTickerHeightPx: 44,
  overlayTickerFullscreenHeightPx: 60,
  // Max visible players in the static ticker row (normal vs fullscreen)
  overlayTickerMaxPlayers: 8,
  overlayTickerMaxPlayersFullscreen: 10,
  // Duration of the cube flip animation for the frame (ms)
  overlayTickerCubeMs: 600,
  // Avatar (player image) size (px) normal vs fullscreen
  overlayTickerAvatarPx: 36,
  overlayTickerAvatarFullscreenPx: 44,
  // Font classes for normal vs fullscreen
  overlayTickerFontClass: 'text-xs sm:text-sm',
  overlayTickerFontClassFullscreen: 'text-sm sm:text-base',
  // Highlight re-detections in the ticker for a brief moment
  overlayTickerHighlightEnabled: true,
  // Highlight duration in ms for re-detected players
  overlayTickerHighlightMs: 3000,
  // Alias for convenience
  highlight_enabled: true,
  // Disable player cache to avoid using expired presigned URLs for images
  playerCacheEnabled: false,
  // Debugging: logs detailed ticker processing to the console
  overlayTickerDebug: true,
};

export default DetectionsConfig;
